export default {"src":"/_next/static/media/helping-sm.colour.0862f764.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};